import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from 'components/Common/MUICustomAutocomplete';

interface IHSCodesOpts {
  formValues: any;
  setFormValues: any;
  aggData: any;
  selectedIndex: any;
  tradePrimaryOpts: any;
  toClear: boolean;
  setCodeOpts: any;
  codeOpts: any;
  setChapterOpts: any;
  chapterOpts: any;
}

const HSCodesOptions: React.FC<IHSCodesOpts> = ({
  tradePrimaryOpts,
  selectedIndex,
  formValues,
  setFormValues,
  toClear,
  setChapterOpts,
  setCodeOpts,
  codeOpts,
  chapterOpts,
}) => {
  const handleSectionSelect = async(e: any) => {
    const obj = {
      ...formValues,
      hsCodeSection: e,
      hsCodeChapter: [],
      hsCode: [],
    };
    setFormValues(obj);
    if (obj && obj.hsCodeSection.length !== 0) {
      setCodeOpts({ isLoading: true, data: {} });
      setChapterOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.trade({
        hsCodeSection: obj.hsCodeSection,
        indexName: selectedIndex,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.hsAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.chapterAgg.buckets);
          },
        );
      }
      setChapterOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleChapterSelect = async(e: any) => {
    const obj = {
      ...formValues,
      hsCodeChapter: e,
      hsCode: [],
    };
    setFormValues(obj);
    if (obj && obj.hsCodeChapter.length !== 0) {
      setCodeOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.trade({
        hsCodeChapter: obj.hsCodeChapter,
        indexName: selectedIndex,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.hsAgg?.buckets.map(
          (bucket: any) => {
            bucket.chapterAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.codeAgg.buckets);
            });
          },
        );
      }
      setCodeOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleCodeSelect = async(e: any) => {
    setFormValues({ ...formValues, hsCode: e });
  };

  const handleListNameSelect = async(e: any) => {
    setFormValues({ ...formValues, listName: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!tradePrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={tradePrimaryOpts.data.listName.buckets}
          placeholder='List Name'
          onChange={handleListNameSelect}
          toClear={toClear}
        />
      )}
      {!tradePrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={tradePrimaryOpts.data.hsAgg.buckets}
          placeholder='HS Code Section'
          onChange={handleSectionSelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!chapterOpts.isLoading ? chapterOpts?.data : []}
        placeholder='HS Code Chapter'
        onChange={handleChapterSelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!codeOpts.isLoading ? codeOpts?.data : []}
        placeholder='HS Code'
        onChange={handleCodeSelect}
        toClear={toClear}
      />
    </div>
  );
};

export default HSCodesOptions;
